var React = require('react');

function IconCycle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M151.4 245.2C73.7 351.6 40.6 493.3 85.3 644.7c41.2 141.5 153.3 252.7 293.9 294.8 146.4 43.8 287.1 13 392.8-62.3 3.5-2.5 4-7.5.9-10.7L702 795.6c-2.3-2.3-6-2.6-8.8-.9-51.9 33-113.6 52.4-179.8 52.4-185.5 0-335.1-149.6-336-334.3l1.8-1.8H344c1.8 0 3.5-.7 4.9-1.9 5.4-5.3 20.3-20 28.1-27.9 2.6-2.8 2.6-7.2 0-9.8M867.3 767.8c3.2 3.2 8.2 2.6 10.7-.9 74.2-105.8 104.2-245.3 61.2-391.8C898 233.6 785.9 122.4 644.4 81.2c-146.4-42.1-284.3-12.1-390 62.3-3.5 2.5-4 7.7-.9 10.7l70.9 70.9c2.3 2.3 6 2.6 8.8.9 51.7-32.3 112.9-51.7 178.9-51.7 185.4 0 336 150.5 336 336H683.3c-1.8 0-3.5.7-4.9 1.9-5.4 5.3-20.3 20-28.1 27.9-2.6 2.8-2.6 7.2 0 9.8"}));
}

IconCycle.displayName = "IconCycle";

IconCycle.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconCycle;

IconCycle.default = IconCycle;
